<div class="bg-background-100 py-4">
  <div class="container-lg">
    <h1 class="d-flex align-items-center mb-0 page-title">
      @if (showReturnIcon) {
        <a href="javascript:;" (click)="returnToPreviousRoute()">
          <span class="pr-3 mr-3 border-right">
            <i-feather name="chevron-left" class="text-gray-dark"></i-feather>
          </span>
        </a>
      }
      {{ text }}
    </h1>
  </div>
</div>
